"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=forgotPasswordPanelConfig.js.map